import ThreeViewObj, { SurfaceMaterial, CameraSettings, ThreeScenePlugin } from "./ThreeView"
import ThreeScene from "./ThreeScene";
import ShapeGenerator from "./ShapeGenerator";
import { ISelectionCandidate, IDragAndDropDirectionStrategy } from './DragAndDrop';
import { TemsObject3D } from "@/CommonTypes";

export default class DragAndDropPlaneDirectionStrategy implements IDragAndDropDirectionStrategy<TemsObject3D> {
    private plane: THREE.Plane;
    private scene: ThreeScene;
    private editMesh: THREE.Object3D;
    private controls: THREE.OrbitControls;

    constructor(scene: ThreeScene, controls: THREE.OrbitControls) {
        this.scene = scene;
        this.controls = controls;
    }
    onDrag(selection: ISelectionCandidate<TemsObject3D>): void {
        let position = selection.intersection.point
        /*  0
           |
           |
  PI/2 ----+----> x   -PI/2
           |
         PI|-PI
           v z
       */
        const theta = this.controls.getAzimuthalAngle();
        let normal: THREE.Vector3;

        let flipGrid = false;
        if (theta < -.75 * Math.PI) {
            normal = new THREE.Vector3(0, 0, 1);  // xy
        } else if (theta < -.25 * Math.PI) {
            normal = new THREE.Vector3(1, 0, 0);  // yz
            flipGrid = true;
        } else if (theta < .25 * Math.PI) {
            normal = new THREE.Vector3(0, 0, -1); // xy
        } else if (theta < .75 * Math.PI) {
            normal = new THREE.Vector3(-1, 0, 0); // yz
            flipGrid = true;
        } else {
            normal = new THREE.Vector3(0, 0, 1);  // xy
        }

        let editOrigin = position.clone();
        const d = -(position.dot(normal));
        if (normal.x === 0) { editOrigin.x = Math.round(editOrigin.x); }
        if (normal.y === 0) { editOrigin.y = Math.round(editOrigin.y); }
        if (normal.z === 0) { editOrigin.z = Math.round(editOrigin.z); }

        this.plane = new THREE.Plane(normal, d);
        this.editMesh = ShapeGenerator.buildGrid(
            flipGrid ? 20 : 10,
            flipGrid ? 10 : 20,
            new THREE.Color(THREE.ColorKeywords.red).getHex(),
            editOrigin,
            this.plane.normal
        );
        this.scene.scene.add(this.editMesh);
    }
    getNewCoordinates(direction: THREE.Line3): THREE.Vector3 {
        return this.plane.intersectLine(direction);
    }
    onDrop(): void {
        this.scene.scene.remove(this.editMesh);
    }
}